import { ApiError } from '@gorila-shared-ui/components';
import { MEDIA_SAFE_GPT_ORIGIN } from '../constants/media';
import { EvidenceMedia } from '../types/evidences';
import { MediaOrigin } from '../types/media';
import { downloadRequest, externalDownloadRequest, getRequest } from './api';
import { historicEvidenceUrl } from './urls/reportUrls';

export const getEvidenceMediaDetail = async (
  clientId: string,
  evidenceId: string,
  subClientId?: string,
): Promise<{ data?: EvidenceMedia; error?: ApiError }> => {
  const queryParams = {
    clientId,
    subClientId,
  };
  const response = await getRequest(historicEvidenceUrl(evidenceId), {
    queryParams,
  });
  return {
    data: response?.data,
    error: response?.error,
  };
};
export const getDownloadMediaUrlByKey = async (
  key: string,
  mediaOrigin?: MediaOrigin,
): Promise<{ file?: Blob; error?: ApiError }> => {
  const response =
    mediaOrigin === MEDIA_SAFE_GPT_ORIGIN ? await externalDownloadRequest(key) : await downloadRequest(key);
  return {
    file: response?.data?.file,
    error: response?.error,
  };
};
